export default {
  auth_url: "https://axel-api.veetal.app/auth",
  api_url: "https://axel-api.veetal.app/api",
  analytics: {
    gaId: "G-43WYBMNE59"
  }
};
